import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { UserProvider } from './providers/UserProvider';
import { ImportedPlayersProvider } from './providers/ImportedPlayersProvider';
import { HomebrewProvider } from './providers/HomebrewProvider';
import { ImagesProvider } from './providers/ImagesProvider';
import { DiceProvider } from './providers/DiceProvider';

ReactDOM.render(
    <UserProvider> 
        <ImportedPlayersProvider> 
            <HomebrewProvider> 
                <ImagesProvider> 
                    <DiceProvider> 
                        <BrowserRouter>
                            <App />
                        </BrowserRouter>
                    </DiceProvider>
                </ImagesProvider> 
            </HomebrewProvider> 
        </ImportedPlayersProvider> 
    </UserProvider>,
    document.getElementById('root')
);